import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToWords'
})
export class NumberToWordsPipe implements PipeTransform {

  private units = [
    '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'
  ];
  private teens = [
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen',
    'sixteen', 'seventeen', 'eighteen', 'nineteen'
  ];
  private tens = [
    '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy',
    'eighty', 'ninety'
  ];
  private thousands = ['', 'thousand', 'million', 'billion'];

  transform(value: string | number): string {
    if (!value) {
      return '';
    }
    const number = parseInt(value.toString(), 10);
    if (isNaN(number)) {
      return 'Invalid number';
    }
    return this.convertToWords(number);
  }

  private convertToWords(num: number): string {
    if (num === 0) {
      return 'zero';
    }

    let words = '';
    let thousandIndex = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        words = this.convertThreeDigits(num % 1000) +
          (this.thousands[thousandIndex] ? ' ' + this.thousands[thousandIndex] : '') +
          ' ' + words;
      }
      num = Math.floor(num / 1000);
      thousandIndex++;
    }

    return words.trim();
  }

  private convertThreeDigits(num: number): string {
    const hundred = Math.floor(num / 100);
    const remainder = num % 100;
    let words = '';

    if (hundred > 0) {
      words += this.units[hundred] + ' hundred ';
    }
    if (remainder > 0) {
      words += this.convertTwoDigits(remainder);
    }
    return words.trim();
  }

  private convertTwoDigits(num: number): string {
    if (num < 10) {
      return this.units[num];
    } else if (num < 20) {
      return this.teens[num - 10];
    } else {
      const ten = Math.floor(num / 10);
      const unit = num % 10;
      return this.tens[ten] + (unit > 0 ? '-' + this.units[unit] : '');
    }
  }

}
